import UserAvatarCircleIcon from '@atlaskit/icon/glyph/user-avatar-circle';
import Spinner from '@atlaskit/spinner';
import ConsentHub from 'atlassian/consent_hub';
import componentLoader from 'utils/component_loader';

import ConfirmModal from 'components/confirm';
import AudienceSpecificSearch from 'components/manage/audience_specific_search';
import BetterErrorPagesGetStarted from 'components/better_error_pages/get_started';
import ComponentToggler from 'components/component_groups';
import HostHelper from 'components/manage/pages/host_helper';
import ExceedingAllocationsDashboard from 'components/manage/admin/exceeding_allocations/exceeding_allocations_dashboard';
import ImportSubscriberForm from 'components/manage/pages/notifications/import_subscriber_form';
import ImportUsersForm from 'components/manage/audience/import_users_form';
import IncidentsSearchField from 'components/manage/incidents_search_field';
import IncidentTemplates from 'components/manage/incident_templates/incident_templates';
import IncidentTemplateForm from 'components/manage/incident_templates/incident_template_form';
import ItemsSelector from 'components/items_selector/items_selector';
import ModifyUser from 'components/manage/organizations/modify_user';
import OrganizationPages from 'components/manage/admin/organizations/pages';
import PageAccessUsersForm from 'components/manage/page_access_users/form';
import PageAccessSearchField from 'components/manage/page_access_search_field';
import PageSubscription from 'components/manage/admin/pages/subscription';
import NotificationsSubscriberManager from 'components/manage/notifications/notifications_subscriber_manager';
import ResendConfirmationLink from 'components/resend_confirmation_link';
import SingleSignOnForm from 'components/manage/pages/single_sign_on_form';
import SsoMetrics from 'components/manage/shared/sso_metrics';
import SubscribersSearchField from 'components/manage/subscribers_search_field';
import UnsubscribeButton from 'components/manage/unsubscriber';
import NewSubscription from 'containers/status/subscriptions/new_subscription';
import EditSubscription from 'containers/status/subscriptions/edit_subscription';
import BackfillDateTimePicker from 'components/backfill_date_time_picker';
import SelectInput from 'components/select_input';
import StatusEmbed from 'containers/status_embed';
import ColorInput from 'components/color_input';
import ActivateAudienceSpecific from 'containers/activate_audience_specific';
import PageAuthentication from 'containers/page_authentication';
import GoogleConfigForm from 'containers/page_authentication/google_config_form';
import SsoConfigForm from 'containers/page_authentication/sso_config_form';
import { AudienceSpecificHeader } from 'containers/audience_index';
import { ClearableDatePicker as DatePicker } from 'components/clearable_date_picker';
import TooltipForbiddenAccess from 'components/tabs/tooltip_forbidden_access';

Object.assign(window, { ConsentHub });
window.ConsentHub = ConsentHub;

componentLoader({
  ConfirmModal,
  AudienceSpecificSearch,
  BetterErrorPagesGetStarted,
  ComponentToggler,
  HostHelper,
  ExceedingAllocationsDashboard,
  ImportSubscriberForm,
  ImportUsersForm,
  IncidentsSearchField,
  IncidentTemplates,
  IncidentTemplateForm,
  ItemsSelector,
  ModifyUser,
  OrganizationPages,
  PageAccessUsersForm,
  PageAccessSearchField,
  PageSubscription,
  NotificationsSubscriberManager,
  ResendConfirmationLink,
  SingleSignOnForm,
  SsoMetrics,
  SubscribersSearchField,
  UnsubscribeButton,
  NewSubscription,
  EditSubscription,
  BackfillDateTimePicker,
  SelectInput,
  StatusEmbed,
  ColorInput,
  Spinner,
  ActivateAudienceSpecific,
  UserAvatarCircleIcon,
  PageAuthentication,
  GoogleConfigForm,
  SsoConfigForm,
  AudienceSpecificHeader,
  DatePicker,
  TooltipForbiddenAccess,
});
